import React, { useState } from 'react';
// @ts-ignore
import { CSVLink } from 'react-csv';
import IconButton from '@mui/material/IconButton';
import { Download as DownloadIcon } from '@mui/icons-material'
import { useTranslation } from "react-i18next";
import Menu from '@mui/material/Menu';
import { Button } from '@mui/material';
import { useMyOrgs } from '../customer/orgs/MyOrgAPIEndpoints';
// @ts-ignore
import { getPrecipUnit, formatUom } from '../../lib/Formatters';

export interface UcButtonHistoricalChartDownloadProps {
    data: any[];
    filename: string;
    palletColor: string;
    selectedMeter: string;
    accountNumber?: string;
    yearOne: string;
    yearTwo: string;
    chartType: string;
    uom: string;
}

export const UcButtonHistoricalChartDownload = (props: UcButtonHistoricalChartDownloadProps) => {
    const { t } = useTranslation();
    const { data, filename, palletColor, selectedMeter, accountNumber, yearOne, yearTwo, chartType, uom } = props;
    const csvLink = React.useRef<any>();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    let orgTempUnit: string | null = null;
    const swrMyOrg = useMyOrgs();

    if (!swrMyOrg.isLoading && swrMyOrg.result?.length > 0) {
        orgTempUnit = swrMyOrg.result[0].temperatureUnit;
    }

    const handleCSVClick = () => {
        csvLink.current.link.click();
        setAnchorEl(null);
    }

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };
    
    const handleClose = () => {
        setAnchorEl(null);
    };

    let modifiedData = data.flatMap((item: any) => {
        let result: any = {};
        if (props.chartType === "month") {
            result["Account Number"] = accountNumber ? ` ${accountNumber}` : '';
            result["Meter Number"] = selectedMeter ? ` ${selectedMeter}` : '';
            result["Date"] = item.tooltipText;
            result[`Total Usage (${formatUom(uom)}) ${yearOne}`] = item.totalUsageYearOne;
            result[`Total Usage (${formatUom(uom)}) ${yearTwo}`] = item.totalUsageYearTwo;
            result[`Avg. Temp. (\u00B0${orgTempUnit}) ${yearOne}`] = item.weatherDataYearOne;
            result[`Avg. Temp. (\u00B0${orgTempUnit}) ${yearTwo}`] = item.weatherDataYearTwo;
            result[`Precip. (${getPrecipUnit(orgTempUnit)}) ${yearOne}`] = item.precipDataYearOne;
            result[`Precip. (${getPrecipUnit(orgTempUnit)}) ${yearTwo}`] = item.precipDataYearTwo;
        }
        else if (props.chartType === "day") {
            const baseFields = {
                "Account Number": accountNumber ? ` ${accountNumber}` : '',
                "Meter Number": selectedMeter ? ` ${selectedMeter}` : ''
            };

            // Divide year one and year two dates into separate rows
            const yearOneRow = {
                ...baseFields,
                "Date": item.yearOneDate,
                ["Total Usage (" + formatUom(uom) + ")"]: item.totalUsageYearOne,
                ["Avg. Temperature (\u00B0" + orgTempUnit + ")"]: item.weatherDataYearOne,
                ["Precipitation (" + getPrecipUnit(orgTempUnit) + ")"]: item.precipDataYearOne
            };

            const yearTwoRow = {
                ...baseFields,
                "Date": item.yearTwoDate,
                ["Total Usage (" + formatUom(uom) + ")"]: item.totalUsageYearTwo,
                ["Avg. Temperature (\u00B0" + orgTempUnit + ")"]: item.weatherDataYearTwo,
                ["Precipitation (" + getPrecipUnit(orgTempUnit) + ")"]: item.precipDataYearTwo
            };

            return [yearOneRow, yearTwoRow];
        }

        return result;
    });

    if (chartType === "day" && modifiedData?.length > 0) {
        modifiedData = modifiedData.sort((a, b) => {
            const dateA = new Date(a.Date);
            const dateB = new Date(b.Date);
            return dateA.getTime() - dateB.getTime();
        });
    }

    return (
        <>
            <IconButton
                sx={{ color: palletColor }}
                onClick={handleClick}
                title={t('Historical Usage Download')}
                data-cy-id={"historicalComparison-download-menu"}
            >
                <DownloadIcon />
            </IconButton>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <Button
                    onClick={handleCSVClick} 
                    style={{ display: 'inline-block', width: '200px', textAlign: 'justify' }}
                    data-cy-id={"historicalComparison-csv-download-button"}
                >
                    <span style={{verticalAlign: 'middle'}}>
                        <img src="/csv-logo.svg" style={{ margin: '0px 5px 0px 5px', verticalAlign: 'middle' }} 
                            alt="CSV Logo" width="35" height="35" /> <span style={{verticalAlign: '-2px'}}>CSV</span>
                    </span>
                </Button>
            </Menu>
            <CSVLink
                style={{ display: "none" }}
                data={modifiedData}
                filename={filename}
                ref={csvLink}
            />
        </>
    )
}